import { motion } from "framer-motion";
import Reveal, { MaskedLine } from "@/components/Reveal";

const PageHero = ({ overline, lines, sub, image, alt, testId }) => (
  <section className="relative min-h-[92vh] flex flex-col justify-end overflow-hidden bg-ink" data-testid={testId}>
    <div className="absolute inset-0">
      <img src={image} alt={alt} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-ink to-transparent" />
    </div>
    <div className="relative z-10 px-6 md:px-12 lg:px-20 pb-16 md:pb-20 pt-40 max-w-7xl mx-auto w-full">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="font-mono text-xs uppercase tracking-[0.25em] font-medium text-brand mb-6"
      >
        {overline}
      </motion.p>
      <h1 className="font-display font-bold leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-bone max-w-4xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.12}>{line}</MaskedLine>
        ))}
      </h1>
      {sub && (
        <Reveal delay={0.55}>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-slate-300 leading-relaxed">{sub}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
